// Persistence helpers for tracking read tickets.
// Extracted to a standalone module to avoid circular dependencies between
// tickets domain logic and redux reducers importing the functions barrel.

export const READ_TICKETS_KEY = "readTickets";

export const getReadTicketListFromPersistance = () =>
  typeof sessionStorage !== "undefined"
    ? sessionStorage.getItem(READ_TICKETS_KEY)
    : null;
